import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

import { FinishEventListener } from '../types/instance';

export const useOnFinish = (onFinish?: FinishEventListener) => {
    useInstanceEffect(
        (instance) => (onFinish ? instance.onFinish(onFinish) : undefined),
        [onFinish]
    );
};
